/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        var browserClass = '';
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        var isFirefox = typeof InstallTrigger !== 'undefined';
        var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
        var isIE = false || !!document.documentMode;
        var isEdge = !isIE && !!window.StyleMedia;
        var isChrome = !!window.chrome && !!window.chrome.webstore;

        if(isOpera) {browserClass='opera';}
        else if(isFirefox) {browserClass='firefox';}
        else if(isSafari) {browserClass='safari';}
        else if(isChrome) {browserClass='chrome';}
        else if(isIE) {browserClass='ie';} 
        else if(isEdge) {browserClass='edge';}  
        $('body').addClass(browserClass);
        
        function sameHeight(row,mobile) {
            var winW = $(window).width();
            if(winW>mobile) {
              var getH, max = 0;
              $(row).find('div[class^=col-]').each(function(){
                $(this).removeAttr('style');
                getH = $(this).outerHeight();
                if(getH>max) {
                  max = getH;
                }
              });
              $(row).find('div[class^=col-]').each(function(){
                $(this).height(max);
              });
            }
            else {
              $(row).find('div[class^=col-]').removeAttr('style');
            }
        }
     
        if($('body').hasClass('safari')) {
            if($('#partners').length) {
              $(window).load(function() {
                sameHeight('#partners',767);
              });
              $(window).resize(function(){
                  sameHeight('#partners',767);
              });
            }
            if($('#team').length) {
               $(window).load(function() {
                sameHeight('#team',767);
               });
              $(window).resize(function(){
                  sameHeight('#team',767);
              });
            }
            if($('section.products .row').length) {
              $(window).load(function() {
                sameHeight('section.products .row',767);
              });  
               $(window).resize(function() {
                sameHeight('section.products .row',767);
              });  
            }
            if($('section.misc .row').length) {
                $(window).load(function() { 
                  sameHeight('section.misc .row',767);
                });  
                 $(window).resize(function() { 
                  sameHeight('section.misc .row',767);
                });  
            }
            if($('.product_feeds').length) {
               $(window).load(function() {
                sameHeight('.product_feeds',991);
               }); 
                $(window).resize(function() {
                sameHeight('.product_feeds',991);
               }); 
            }
            if($('.product_block_feeds').length) {
               $(window).load(function() {
                sameHeight('.product_block_feeds',767);
               }); 
              $(window).resize(function() {
                sameHeight('.product_block_feeds',767);
               }); 
            }
        
        }


        $.getJSON($blogUrl+'/weather/', function(data){
            var div = $('header#top_main .weather_widget');
            var icon = $blogTheme+'/dist/images/'+data.weather[0].icon+'.png';
            var d = data.weather[0].description;
            //d += '<br>Pressure: '+data.main.pressure+'hPa | Humidity: '+data.main.humidity+'%';
            d += '<br>Humidity: '+data.main.humidity+'%';
            //d += '<br>Dungarvan Waterford';

            div.append('<img src="'+icon+'" />');
            div.append('<div class="temp">'+Math.ceil(data.main.temp)+'°C</div>');
            div.append('<div class="data">'+d+'</div>');

            div.clone().appendTo( "#weather_mobile" );
        });
        $( "form.validate" ).submit(function( e ) {
          e.preventDefault();
          var input_token = $(this).find('input.token');

          if($(this).hasClass('antispam')) {
            if(input_token.length && $(this).parsley().isValid()) {
              $(this)[0].submit();
            }
            else if(!input_token.length) {
              $(this).find('.error-robot').show().html('Please select the box above to confirm you are not a robot');
            }
          }
          else {
             if($(this).parsley().isValid()) {
               $(this)[0].submit();
             }
          }
        });

        $( "form.validate" ).parsley();

        $('.not-robot').click(function(e){
          e.preventDefault();
          var loaded = $(this).attr('data-loaded');
          if(loaded==='false') return false;
          var token_name = $(this).attr('data-role');
          var url = $blogUrl+'/generate_token/'+token_name;
          var _this = $(this); 
          _this.parent().find('.error-robot').hide().html('');
          _this.removeClass('fa-square-o').addClass('fa-spinner fa-pulse');
          $.ajax({
            type: 'GET',
            url: url,
            data: url,
            success: function(response){
              _this.attr('data-loaded','false');
              _this.removeClass('fa-spinner fa-pulse not-robot').addClass('fa-check-circle');
              _this.parent().append('<input type="hidden" class="token" name="token_'+token_name+'" value="'+response+'" />');
            },
            error: function(xhr, ajaxOptions, thrownError){
              console.log(xhr);
              console.log(ajaxOptions);
              console.log(thrownError);
                    
            }
          });	
        });

        $('#menu_opener').click(function(){
           $('body').toggleClass('menu_opened');
        });
        
        $('#primary ul li i.open_sub').click(function(e){
          e.preventDefault();
          var topOffset = ($(this).offset().top);
          if(!$(this).parent().hasClass('sub_opened')) {
              topOffset = topOffset - 60;
              $('#primary ul li').removeClass('sub_opened');
              $('#primary ul li .sub_nav').slideUp(300);
              
              $(this).parent().addClass('sub_opened');
              $(this).next('.sub_nav').slideDown(300);
              
              //setTimeout(function(){  }, 300);
          }
          else {
            $(this).parent().removeClass('sub_opened');
            $(this).next('.sub_nav').slideUp(300);
          }
          // $('#primary').animate({ scrollTop: topOffset }, 300);
        });
        
        //if($(window).width()<=1025) {
				  var lastScroll = 0;
				  $(window).scroll(function(){
					  var st = $(this).scrollTop();
					  if (st > lastScroll && st>150){
						 //Down
						 $('#top_main').removeClass('shhow');
					  } 
					  else {
						  //Up
						  $('#top_main').addClass('shhow');
					  }
					  lastScroll = st;
				  });
				//}

      },
      finalize: function() {
         var headerH = $('#top_main').outerHeight();
          $(window).scroll(function(){
            var st = $(this).scrollTop();
            if (st > headerH){
              $('#top_main').addClass('go_fixed');
              $('body').css('padding-top',headerH);
            }
            else {
              $('#top_main').removeClass('go_fixed');
              $('body').css('padding-top',0);
            }
          });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        
          $('.home_arrow i').click(function(){
            var headerH = $('#top_main').outerHeight();
            var scrollTo = $(this).position().top;
            $("html, body").animate({ scrollTop: scrollTo - headerH }, 600);
            console.log(scrollTo);
          });
      }
    },
    // About us page, note the change from about-us to about_us.
    'contact_us': {
      init: function() {
        if(typeof $lat !== 'undefined' && typeof $lng !== 'undefined'){
        $(window).load(function(){
				  var winW = $(window).width(); 
				 var ico = (typeof $map_ico !== 'undefined') ? $map_ico : null;
				
					var mapZoom;
					mapZoom = 11;
					
					var draggable = (winW>767) ? true : false;
				  
				  var mapOptions = {
					zoom: mapZoom,
					center: new google.maps.LatLng($lat,$lng),
					disableDefaultUI: true,
					draggable: draggable,
					scrollwheel: false, 
					panControl: false,
					zoomControl: true,
					mapTypeControl: false
				  };
				
				  map = new google.maps.Map(document.getElementById("map"),mapOptions);
				  
				
				var marker = new google.maps.Marker({
					position: new google.maps.LatLng($lat,$lng),
          icon: ico,
					map: map,
				});	
				
					var logo = '';	 
					var contentString;
					 //contentString = '<img src="'+logo+'" width="150" style="margin:10px 0"/><p class="black_txt">Number 10, The Parade, Kilkenny, Ireland<br />+353 56 7726 400<br />mail@threesixty.ie</p>';	 
					if($('.address_field').length) {
						contentString = $('.address_field').html();
					}
					
					var infowindow = new google.maps.InfoWindow({ 
						content: contentString,
							maxWidth: 600
					});	  		
					google.maps.event.addListener(marker, 'click', function() {
						infowindow.open(map,marker);
					});	
        });	
		  	}
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
